<template>
  <v-main class="fill-height">
    <v-container class="password-reset">
      <v-row class="d-flex justify-center">
        <v-col lg="4" md="6" sm="12">
          <v-card v-if="token">
            <v-card-title> {{ $t('Password Reset') }} </v-card-title>
            <v-card-subtitle>
              {{
                $t(
                  'Your password must be at least {min} characters including lowercase and uppercase letters, and digits',

                  {
                    min: MIN_PASS_LENGTH,
                  }
                )
              }}
            </v-card-subtitle>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-text-field v-model="password" required :rules="passRules" type="password" :label="$t('Password')" />
                <v-text-field
                  v-model="repeat"
                  required
                  :rules="repeatRules"
                  type="password"
                  :label="$t('Repeat Password')"
                />
              </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn text color="primary" :loading="loading" @click="submit"> {{ $t('Set New Password') }} </v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-else>
            <v-card-title> {{ $t('Invalid token') }} </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Dataman from 'App/Dataman';
import { MIN_PASS_LENGTH, makePassRules } from 'Lib/Password';

export default {
  name: 'PasswordReset',
  data() {
    return {
      valid: false,
      loading: false,
      password: '',
      repeat: '',
    };
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
    passRules() {
      return makePassRules(this.$t.bind(this));
    },
    repeatRules() {
      return [
        (v) => !!v || this.$t('Please repeat your password'),
        (v) => v === this.password || this.$t('Passwords are not identical'),
      ];
    },
    MIN_PASS_LENGTH() {
      return MIN_PASS_LENGTH;
    },
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      const { token, password } = this;
      this.loading = true;
      Dataman.passwordReset
        .reset({ token, new_password: password })
        .then((res) => {
          if (res.status === 200) {
            this.$router.push('/?login');
          }
        })
        .catch((err) => {
          this.$toaster.error(err?.response?.data['hydra:description'] || err.response?.data?.description, 7e3);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
